import { CommonModule } from '@angular/common';
import { ResSupportComponent } from './ressupport.component';
import {  NgModule } from '@angular/core';
import {AppRoutingModule} from '../app.routing'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}

@NgModule({
    imports: [
      AppRoutingModule,
      CommonModule,
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ],
    declarations: [
        ResSupportComponent
    ],
  
    providers: [

    ]
  })
export class ResSupportModule {}